import $ from 'jquery'
import M from 'materialize-css'

$('form input').on('change', () => {
    M.updateTextFields()
});

$('form input[data-placeholder]').on('focus blur', (e) => { // Show/hide placeholder on focus/blur to work nicely with MaterializeCSS
    const $target = $(e.target);
    if (e.type === 'focus') {
        $target.attr('placeholder', $target.data('placeholder'))
    } else {
        if ($target.val() === "") {
            $target.parent().find('label').removeClass('active');
        }
        $target.removeAttr('placeholder');
    }
});

$.each($('form input[required], form select[required], form textarea[required]').not('hidden'), (key, elem) => {
    let label = $(elem).parents('.input-field').find('label');
    if (!label.children('small').length) {
        label.append('<small class="red-text"> *</small>')
    }
});

document.addEventListener('DOMContentLoaded', function() {
    var elems = document.querySelectorAll('select');
    var instances = M.FormSelect.init(elems);
});






// WEBPACK FOOTER //
// ./resources/assets/js/forms.js